var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgG2165(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.909,
    height: 12.402,
    viewBox: "0 0 12.909 12.402",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g2165",
    transform: "translate(684.547 790.542)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "rect1147",
    d: "M-672.138-666.261v3.427a.143.143,0,0,1-.128.154H-683.92a.143.143,0,0,1-.128-.154v-3.427",
    transform: "translate(0 -115.96)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 6.2,
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("g", {
    id: "g1663",
    transform: "translate(-681.036 -791.64)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path1149",
    d: "M-155.8,47.138v8.054",
    transform: "translate(158.744 -45.54)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1151",
    d: "M-196.34,156.556l-2.943-3.007",
    transform: "translate(199.283 -146.347)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "path1153",
    d: "M-155.8,156.556l2.943-3.007",
    transform: "translate(158.744 -146.347)",
    fill: "none",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgG2165);
export default __webpack_public_path__ + "static/media/g2165.0bb19a1dbe788d54c4c3533d9b7e9363.svg";
export { ForwardRef as ReactComponent };